import { useCallback } from 'react';
import { logError } from 'utils/logger';
import { useMutation } from '@apollo/client';
import { useNotifications } from 'modules/notification';
import { MutationHookOptions } from '@apollo/client/react/types/types';

import { customersApi } from '../index';
import { CreateCustomerAccountInput } from '../../mapper/customerAccount';

export function useCustomerAccount() {
  const { showNotification } = useNotifications();

  const [onCreate, { loading: isCreating }] = useMutation(customersApi.account.create);

  const handleCreateCustomerAccount = useCallback(
    async (
      input: CreateCustomerAccountInput,
      fetchOptions?: (api: typeof customersApi) => Omit<MutationHookOptions, 'variables'>
    ) => {
      try {
        const { data } = await onCreate({
          variables: {
            input,
          },
          ...(typeof fetchOptions == 'function' ? fetchOptions(customersApi) : {}),
        });

        const result = data?.customer?.result;

        if (result?.success) {
          showNotification('Customer Account created successfully');
        } else {
          showNotification(result?.error ?? 'Failed to create Customer Account', { type: 'error' });
        }

        return result;
      } catch (error: unknown) {
        showNotification('Failed to create Customer Account', { type: 'error' });
        logError(error);
      }
    },
    [onCreate, showNotification]
  );

  return {
    isCreating,
    handleCreateCustomerAccount,
  };
}
